/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from "react";
import { LeaveAttendanceApi } from "../../../services/LeaveAttendance";
import { useParams } from "react-router-dom";

interface LeaveProps {
  userData: any
  userRole: string,
  isOwnAttendance: boolean,
  sidebarAccess: RoleAccess[];
  leaveRequestData: any
  BalancedLeave: any
  setleaveRequestData: (data: any) => void
  // setleaveRequestDatas:(data:any) => void
  setLeaveRender: (data: any) => void
  leaveRender: any

}
interface RoleAccess {
  access: string;
}


const ViewReqPendLeave = (props: LeaveProps) => {
  const [BalancedLeave, setBalancedLeave] = useState<any>([]);
  // const [leaveRequestData, setleaveRequestData] = useState<any>([]);

  const { getRequestedLeave, getBalancedLeave } = LeaveAttendanceApi();
  const { userid } = useParams<{ userid: string }>();
  const userId = parseInt(userid)

  useEffect(() => {
    getPendingLeaveData();
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [props.leaveRender]);
  useEffect(() => {
    getLeaveBalanceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.BalancedLeave]);
  // const userIdAsString: string = `${props.userData.id}`;
  const getPendingLeaveData = async () => {
    try {
      const response = await getRequestedLeave(userId);

      props.setleaveRequestData(response.data.data);

      // props.setleaveRequestDatas(response.data.status);

    } catch (error) {
    }
  };
  const getLeaveBalanceData = async () => {
    try {
      const data = await getBalancedLeave(userId);
      setBalancedLeave(data.data.data);
    } catch (error) {
    }
  };



  return (
    <div className='w-full bg-white mt-5 p-5 rounded-xl shadow-lg'>
      <br />
      <div className="text-left">
        <h2 className="text-left text-slate-800 font-bold text-2xl mb-4">Leave Balance </h2>
        <div className='overflow-auto'>
          <table className="w-full divide-x dark:divide-gray-400 rounded-lg overflow-hidden">
            <thead className=" ">
              <tr >
                <th className="text-center px-4 sm:px-6 py-3 bg-green-800 dark:bg-green-800 text-xs sm:text-sm leading-4 font-medium text-green-100 dark:text-green-100 uppercase tracking-wider">Leave Type</th>
                <th className="text-center px-4 sm:px-6 py-3 bg-green-800 dark:bg-green-800 text-xs sm:text-sm leading-4 font-medium text-green-100 dark:text-green-100 uppercase tracking-wider">Balance</th>
                <th className="text-center px-4 sm:px-6 py-3 bg-green-800 dark:bg-green-800 text-xs sm:text-sm leading-4 font-medium text-green-100 dark:text-green-100 uppercase tracking-wider">Total</th>
              </tr>
            </thead>
            <tbody className="bg-gray-100 divide-y divide-gray-300 text-center">
              {BalancedLeave.length > 0 ? (
                BalancedLeave.map((leave: any, index: number) => (
                  <tr key={index} className="divide-x divide-gray-300">
                    <td className="text-center p-2">{leave.leaveType}</td>
                    <td className="text-center p-2">{leave.defaultValueLeaveBalance}</td>
                    <td className="text-center p-2">{leave.defaultValueLeave}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={3} className="text-center p-2">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>

          </table>

        </div>
      </div>
      <br />
    </div>
  )
}

export default ViewReqPendLeave;